import { render } from "./account.vue?vue&type=template&id=af840d3a&scoped=true&ts=true"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"

import "./account.vue?vue&type=style&index=0&id=af840d3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af840d3a"]])

export default __exports__